import { type TFunction } from 'i18next';

import { type SpecContractType } from '@/common/types/contract';

const getTexts = (
  t: TFunction,
): Record<SpecContractType, { inProgres: string; forOpening: string }> => ({
  Grand: {
    inProgres: t('Complete the contract and get:'),
    forOpening: t('Complete it before the timer runs out'),
  },
  Custom: {
    inProgres: '',
    forOpening: '',
  },
  Golden: {
    inProgres: t('Complete the contract and get:'),
    forOpening: t('Complete it before the timer runs out'),
  },
  Blitz: {
    inProgres: t('Complete the contract and get:'),
    forOpening: t('Complete {{steps}} steps before the timer runs out', {
      steps: 4,
    }),
  },
});

export { getTexts };
